import { BlogIndex } from '@kkf/design'
import { POSTS } from '../data/blog'
import { useT } from '../i18n'

/**
 * The Foundation's blog index.
 *
 * The page is `@kkf/design`'s `BlogIndex` — the same one the garage, the resort and
 * Partners mount, with the posts each of them carries. This file is what is left when the
 * shared part is shared: which posts, and what this site calls its blog.
 *
 * There used to be a second, grid-and-featured-post layout on this route, with the list at
 * `/blog-2`. The grid was dropped; this is the only blog index, and it took over `/blog`
 * and every link that already pointed there.
 *
 * **`/blog` is in this app's `header.plainRoutes`** — the page opens on its own pale
 * content and the bar's links are white at rest. `BlogIndex` carries `.ul-plain-page-top`
 * itself; the route list is the half it cannot do for itself. See `SiteShell`.
 */
export function BlogPage() {
  const t = useT()
  return <BlogIndex posts={POSTS} title={t('page.blogs')} />
}
